document.addEventListener('alpine:init', () => {
  Alpine.store('modals', {
    leftDrawer: { open: false, contents: '' },
    rightDrawer: { open: false, contents: '' },
    modal: { open: false, contents: '' },
    popup: { open: false, contents: '' },
    modals: { cart: 'rightDrawer' },
    closeTimers: {},
    register(name, slotName) {
      this.modals[name] = slotName;
    },
    open(name) {
      if (this.modals[name]) {
        const slotName = this.modals[name];

        if (this.closeTimers[slotName]) {
          clearTimeout(this.closeTimers[slotName]);
          this.closeTimers[slotName] = null;
        }

        document.body.dispatchEvent(
          new CustomEvent(`${name}-will-open`, { bubbles: true })
        );

        document.body.dispatchEvent(
          new CustomEvent(
            `${slotName.replace('Drawer', '-drawer')}-will-open`,
            { bubbles: true }
          )
        );

        this[slotName].contents = name;
        this[slotName].open = true;

        document.body.dispatchEvent(
          new CustomEvent(`${name}-is-open`, { bubbles: true })
        );

        document.body.dispatchEvent(
          new CustomEvent(`${slotName.replace('Drawer', '-drawer')}-is-open`, {
            bubbles: true,
          })
        );
      }
    },
    close(nameOrSlotName) {
      let name, slotName;

      if (this.modals[nameOrSlotName]) {
        name = nameOrSlotName;
        slotName = this.modals[nameOrSlotName];
      } else {
        slotName = nameOrSlotName;
        name = this[slotName]?.contents || slotName;
      }

      if (!this[slotName]) {
        return;
      }

      if (this.closeTimers[slotName]) {
        clearTimeout(this.closeTimers[slotName]);
      }

      document.body.dispatchEvent(
        new CustomEvent(`${name}-will-close`, { bubbles: true })
      );

      this[slotName].open = false;

      this.closeTimers[slotName] = setTimeout(() => {
        if (this[slotName].open === false && this[slotName].contents === name) {
          this[slotName].contents = '';
        }
        this.closeTimers[slotName] = null;
      }, 300);

      document.body.dispatchEvent(
        new CustomEvent(`${name}-is-closed`, { bubbles: true })
      );
    },
  });
});
